<script>
  import axios from "axios";
  import Layout from "../../layouts/auth";

import appConfig from "@/app.config";
  /**
   * Forgot Password component
   */
  export default {
    page: {
      title: "Forgot Password",
      meta: [
        {
          name: "description",
          content: appConfig.description,
        },
      ],
    },
    components: {
      Layout,
    },
    data() {
      return {
        data:{
          name: ""
        },
        nameError:"",
        choiceError:"",
        codeError:"",
        codeMsg:"",
        passwordError:"",
        isTryingReset:false,
        isChoosing:false,
        isVerifying:false,
        isResetting:false,
      choice:{
        selected: '',
        user: '',
      },
        verify:{
          code: '',
          user: '',
        },
        reset:{
          password: '',
          confirm: '',
          user: '',
        },
        options: { email: '', phone: '' },
      };
    },
    methods: {
      tryToReset(){
        this.isTryingReset=true;
        if (this.data.name=="" || this.data.name==null){
          this.nameError="Valid username is required";
          this.isTryingReset=false;
          return;
        }else {
          this.nameError="";
        }
  
        axios.post('reset', this.data).then(response => {
          if (response.status==201){
            this.nameError=response.data.msg;
            this.isTryingReset=false;
          }else {
            let phoneResult = response.data.contact;
            let mailResult = response.data.email;
            let mailLength=mailResult?mailResult.length:0;
            let phoneLength=phoneResult.toString().length;
            let
                mailCode = mailResult?mailResult.charAt(0)+""+mailResult.charAt(1)+""+mailResult.charAt(2)+"*******"+mailResult.charAt(mailLength-3)+""+mailResult.charAt(mailLength-2)+""+mailResult.charAt(mailLength-1):'';
            let
                phoneCode = "*******"+phoneResult.toString().charAt(phoneLength-3)+""+phoneResult.toString().charAt(phoneLength-2)+""+phoneResult.toString().charAt(phoneLength-1);
            
            this.options.phone = phoneCode;
            this.options.email = mailResult?mailCode:'No email found for the user';
            this.choice.user = response.data.id;
            this.isTryingReset=false;
            document.getElementById('email-card').style.display="none";
            document.getElementById('choice-card').style.display="block";
            document.getElementById('code-card').style.display="none";
            document.getElementById('password-card').style.display="none";
          }
        }).catch(()=>{
          this.isTryingReset=false;
          this.nameError="Something went wrong. Try again";
        })
  
      },
  
      resetChoice(){
        this.isChoosing=true;
        if (this.choice.selected=="" || this.choice.selected==null){
          this.choiceError="Please choose where to receive the reset code";
          this.isChoosing=false;
          return;
        }else {
          this.choiceError="";
        }
  
        axios.post('reset/choice', this.choice).then(response => {
          if (response.status==200){
            this.codeMsg=response.data.msg;
            this.verify.user = response.data.user;
            this.isChoosing=false;
            document.getElementById('email-card').style.display="none";
            document.getElementById('choice-card').style.display="none";
            document.getElementById('password-card').style.display="none";
            document.getElementById('code-card').style.display="block";
          }else {
            this.choiceError="Something went wrong. Try again";
            this.isChoosing=false;
          }
        }).catch(()=>{
          this.isChoosing=false;
          this.choiceError="Something went wrong. Try again";
        })
  
      },
  
      verifyCode(){
        this.isVerifying=true;
        if (this.verify.code.length != 5){
          this.codeError="Please enter a valid code";
          this.isVerifying=false;
          return;
        }else {
          this.codeError="";
        }
  
        axios.post('reset/verify', this.verify).then(response => {
          this.isVerifying=false;
          if (response.status==201){
            this.codeError=response.data.msg;
            this.isVerifying=false;
          }else {
            this.reset.user=response.data.user
            document.getElementById('email-card').style.display="none";
            document.getElementById('choice-card').style.display="none";
            document.getElementById('password-card').style.display="block";
            document.getElementById('code-card').style.display="none";
            this.isVerifying=false;
          }
        }).catch(()=>{
          this.isVerifying=false;
          this.codeError="Verification failed";
        })
  
      },
  
      resetPassword(){
        this.isResetting=true;
        if (this.reset.password.length < 5){
          this.passwordError="Please enter a strong password of at least 5 characters";
          this.isResetting=false;
          return;
        }else {
          this.passwordError="";
        }
  
        if (this.reset.password != this.reset.confirm){
          this.passwordError="Password do not match. Try again";
          this.isResetting=false;
          return;
        }else {
          this.passwordError="";
        }
  
        axios.post('reset/password', this.reset).then(response => {
          this.isResetting=false;
          if (response.status==200){
            this.isResetting=false;
            this.$router.push('/');
          }else {
            this.isResetting=false;
            this.passwordError="Password resetting failed. Try again";
          }
        }).catch(()=>{
          this.isResetting=false;
          this.passwordError="Password resetting failed. Try again";
        })
  
      },
    },
  };
  </script>
  
  <template>
    <Layout>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
  
            <div class="card-body pt-0">
              <div>
                  <div class="row">
                    <div class="col-md-2">
                      <div class="avatar-md profile-user-wid mt-3">
                    <!-- <span class="avatar-title rounded-circle bg-light">
                      <img src="@/assets/images/logomain.png" alt height="40" />
                    </span> -->
  
                      </div>
                    </div>
                    <div class="col-md-10">
                      <div class="text-primary p-4">
                        <h4 class="text-warning">FORGOT PASSWORD</h4>
                        <p variant="warning">Enter your user name or contact below to reset your Poscream password.</p>
                      </div>
                    </div>
                  </div>
              </div>
              <!-- Email card-body -->
              <div class="p-2" id="email-card" style="display: block">
                <form @submit.prevent="tryToReset">
                  <div class="mb-3">
                    <label for="username">Username or Contact</label>
                    <input type="text" required v-model="data.name" class="form-control" id="username"
                           placeholder="Enter username or contact"/>
                    <div class="text-danger" v-if="nameError">
                      <em>{{nameError}}</em>
                    </div>
                  </div>
                  <div class="mt-3 d-grid">
                    <b-button type="submit" variant="warning" class="btn-block">
                      Send Password Reset code
                      <b-spinner v-if="isTryingReset==true" variant="warning" small role="status"></b-spinner>
                    </b-button>
                  </div>
                </form>
              </div>
            <!-- end Email card-body -->
  
            <!-- Choose where send code -->
            <div class="p-2" id="choice-card" style="display: none">
              <form @submit.prevent="resetChoice">
                <div class="mb-3 text-center">
                  <b-form-group label="Select where to get the code" v-slot="{ ariaDescribedby }">
                    <b-form-radio v-model="choice.selected" :aria-describedby="ariaDescribedby" name="some-radios"
                                  value="email"><i>Get reset code in email: </i><strong> {{options.email}}</strong></b-form-radio>
                    <b-form-radio v-model="choice.selected" :aria-describedby="ariaDescribedby" name="some-radios"
                                  value="phone"><i>Get reset code in SMS: </i><strong> {{options.phone}}</strong></b-form-radio>
                  </b-form-group>
                  <div class="text-danger" v-if="choiceError">
                    <em>{{choiceError}}</em>
                  </div>
                </div>
                <div class="mt-3 d-grid">
                  <b-button type="submit" variant="warning" class="btn-block">
                    Confirm
                    <b-spinner v-if="isChoosing==true" variant="light" small role="status"></b-spinner>
                  </b-button>
                </div>
              </form>
            </div>
              <!-- end Choose where send code -->
  
              <!-- Enter the sent code -->
              <div class="p-2" id="code-card" style="display: none">
                <form @submit.prevent="verifyCode">
                  <div class="text-primary mb-3" v-if="codeMsg">
                    <em>{{codeMsg}}</em>
                  </div>
                  <div class="mb-3 text-center">
                    <input type="number" required v-model="verify.code" class="form-control"
                           placeholder="Enter Code"/>
                    <div class="text-danger" v-if="codeError">
                      <em>{{codeError}}</em>
                    </div>
                  </div>
                  <div class="mt-3 d-grid">
                    <b-button type="submit" variant="primary" class="btn-block">
                      Verify code
                      <b-spinner v-if="isVerifying==true" variant="light" small role="status"></b-spinner>
                    </b-button>
                  </div>
                </form>
              </div>
              <!-- end Enter the sent code -->
  
              <!-- create new password -->
              <div class="p-2" id="password-card" style="display: none">
                <form @submit.prevent="resetPassword">
                  <div class="text-primary mb-3">
                    <p>Create your new password</p>
                  </div>
                  <div class="mb-3 text-center">
                    <input type="password" required v-model="reset.password" class="form-control"
                           placeholder="Enter new password"/>
                    <div class="text-danger" v-if="passwordError">
                      <em>{{passwordError}}</em>
                    </div>
                  </div>
                  <div class="mb-3 text-center">
                    <input type="password" required v-model="reset.confirm" class="form-control"
                           placeholder="Confirm password"/>
                  </div>
                  <div class="mt-3 d-grid">
                    <b-button type="submit" variant="warning" class="btn-block">
                      Reset Password
                      <b-spinner v-if="isResetting==true" variant="light" small role="status"></b-spinner>
                    </b-button>
                  </div>
                </form>
              </div>
              <!-- end create new password -->
          </div>
  
          </div>
          <!-- end card -->
  
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © Poscream. Visit our website <a href="https://poscream.com/">Poscream Website</a> </div>
              <div class="col-sm-6">
                <div variant="warning" class="text-sm-end d-none d-sm-block">Design & Developed by <a href="https://nugsoft.com/">Nugsoft Technologies</a></div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </Layout>
  </template>
  
  <style lang="scss" module></style>
  